import type { PageTour } from '../types';

export const resourcesTour: PageTour = {
  id: 'resources',
  label: 'Resources Tour',
  steps: [
    {
      target: '[data-tour="resources-header"]',
      title: 'Resource Management',
      content: 'Plan and manage resource allocation across projects. See who\'s available and who\'s overbooked.',
    },
    {
      target: '[data-tour="resources-filters"]',
      title: 'Filters',
      content: 'Filter resources by team, skill set, or availability to find the right people for your project.',
    },
    {
      target: '[data-tour="resources-grid"]',
      title: 'Resource Overview',
      content: 'View resource allocation at a glance. The grid shows each person\'s assignments and availability.',
    },
  ],
};
